import { Formik, Form } from 'formik';
import { roundNum } from 'utils/numbers';
import Loader from 'features/Loader/Loader';
import { createFoodSchema } from 'utils/validators/nutrition';
import { connect } from 'react-redux';
import { createFood } from 'features/nutrition/ducks/nutritionActions';
import React from 'react';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Title from 'shared/components/title/Title';
import CreateFoodForm from './CreateFoodForm';
import FoodData from './FoodData';

class CreateFood extends React.Component {
  render() {
    const {
      handleReturnToInitialStep,
      handleIngredientSubmission,
      headerTitle,
      nutritionPlan,
      createFood
    } = this.props;

    return (
      <div className="create-food">
        <div className="container">
          <Breadcrumb>
            <Breadcrumb.Item href="/nutrition">Nutrition</Breadcrumb.Item>
            <Breadcrumb.Item href={`/nutrition/${nutritionPlan.id}`}>
              {nutritionPlan.name}
            </Breadcrumb.Item>
            <Breadcrumb.Item onClick={handleReturnToInitialStep}>
              {headerTitle}
            </Breadcrumb.Item>
            <Breadcrumb.Item active>Create New Food</Breadcrumb.Item>
          </Breadcrumb>
          <Formik
            enableReinitialize={true}
            initialValues={{
              name: '',
              calories: 0,
              fat: 0,
              protein: 0,
              carbs: 0,
              weight_grams: 0,
              quantity_size: 1
            }}
            onSubmit={values => {
              const quantitySize = Number(values.quantity_size);
              createFood({
                name: values.name,
                calories: roundNum(Number(values.calories) / quantitySize),
                fat: roundNum(Number(values.fat) / quantitySize),
                protein: roundNum(Number(values.protein) / quantitySize),
                carbs: roundNum(Number(values.carbs) / quantitySize),
                weight_grams: roundNum(
                  Number(values.weight_grams) / quantitySize
                ),
                measurement_unit: 'servings'
              });
              handleIngredientSubmission({
                isNew: true,
                name: values.name,
                calories: Number(values.calories),
                fat: Number(values.fat),
                protein: Number(values.protein),
                carbs: Number(values.carbs),
                weight_grams: Number(values.weight_grams),
                quantity_size: quantitySize,
                measurement_unit: 'servings'
              });
            }}
            validationSchema={createFoodSchema}
          >
            {formik => (
              <Form>
                {formik.isSubmitting ? (
                  <Loader />
                ) : (
                  <div>
                    <Title
                      pageTitle="Create New Food"
                      buttonText="Save"
                      linkText="Cancel"
                      cancelBtn={handleReturnToInitialStep}
                    />
                    <CreateFoodForm />
                    <FoodData />
                  </div>
                )}
              </Form>
            )}
          </Formik>
        </div>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    createFood: food => dispatch(createFood(food))
  };
}

export default connect(
  null,
  mapDispatchToProps
)(CreateFood);
